module.exports = "/images/is.svg";